
import React, { useState, useEffect, useRef } from 'react';
import DownArrowIcon from '../../assets/svg/Distribution/downArrow.svg';

const DropdownCell = ({ row, field, options, updateRow }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const displayValue = (() => {
    const value = row.original[field];
    if (Array.isArray(value)) {
      return value.map((item) => (typeof item === 'object' ? item.name || item : item)).join(', ');
    }
    if (typeof value === 'object' && value !== null) {
      return value.name || 'Select...';
    }
    return value || 'Select...';
  })();

  const handleSelect = (value) => {
    const selectedOption = options.find((opt) => opt.name === value);
    updateRow(row.index, field, selectedOption.name); // Pass only the name
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        background: 'transparent',
      }}
      ref={dropdownRef}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: '100%',
          padding: '5px',
          color: '#fff',
          borderRadius: '4px',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          isolation: 'isolate',
        }}
        className="dropdown-cell"
      >
        <span>{displayValue}</span>
        <span style={{ marginRight: '5px' }}>
          <img src={DownArrowIcon} style={{ width: 10 }} alt="Export" />
        </span>
      </div>
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            background: '#333',
            border: '1px solid #444',
            borderRadius: '4px',
            marginTop: '2px',
            zIndex: 10,
            maxHeight: '200px',
            overflowY: 'auto',
            isolation: 'isolate',
          }}
          className="dropdown-popup"
        >
          {options?.map((option) => {
            const isSelected = displayValue === option.name;
            return (
              <label
                key={option.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '5px 10px',
                  color: '#fff',
                  cursor: 'pointer',
                  borderBottom: '1px solid #444',
                  background: 'transparent',
                  fontSize: '13px',
                }}
                onClick={() => handleSelect(option.name)}
              >
                <div
                  style={{
                    width: '14px',
                    height: '14px',
                    borderRadius: '50%',
                    border: `2px solid ${isSelected ? '#E9E9E9' : '#606264'}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '8px',
                  }}
                >
                  {isSelected && (
                    <div
                      style={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        backgroundColor: '#E9E9E9',
                      }}
                    />
                  )}
                </div>
                {option.name}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DropdownCell;